module.exports = __webpack_public_path__ + "img/n7.2a3aa016.jpg";